<template>
  <v-bottom-sheet
      v-model="sheet"
      persistent
      no-click-animation
      content-class="bottom-sheet-menu"
  >
    <div class="btn-area" v-if="regId === userKey">
      <v-btn color="primary" class="btn-default"
             block x-large depressed
             @click="onEdit()">수정하기</v-btn>
      <v-divider />
      <v-btn color="primary" class="btn-default"
             block x-large depressed
             @click="onDelete()" v-if="isShowDelete">
        삭제하기
      </v-btn>
    </div>
    <div class="btn-area" v-else>
      <v-btn color="primary" class="btn-default"
             block x-large depressed
             @click="onReport()">신고하기</v-btn>
    </div>
    <v-btn color="primary" class="btn-basic"
           block x-large depressed
           @click="close()">취소</v-btn>
  </v-bottom-sheet>
</template>
<script>
import { mixinAuth } from '@/mixins'

export default {
  components: {},
  mixins: [ mixinAuth ],
  data: () => ({
    sheet: false,
    payload: null
  }),
  computed: {
    regId () {
      if (this.payload && this.sheet) {
        if (this.payload.gubun === 'cmnt') { // 댓글의 경우
          return this.payload.item.cmntRegUserKey
        }
        return this.payload.item.regUserKey
      }
      return null
    },
    isShowDelete () {
      if (this.payload && this.sheet) {
        return this.payload.item.cmntCnt === '0' || this.payload.item.cmntCmntCnt === '0'
      }
      return false
    }
  },
  methods: {
    open (value) {
      this.payload = value
      this.sheet = true
    },
    close () {
      this.sheet = false
      this.payload = null
    },
    onEdit () { // 수정하기
      this.$emit('onEvent', { fn: 'editModalOpen', item: this.payload.item, gubun: this.payload.gubun, index: this.payload.index })
      this.close()
    },
    onReport () { // 신고하기
      this.$emit('onEvent', { fn: 'editModalOpen', item: this.payload.item, gubun: 'post', index: this.payload.index })
    },
    onDelete () {
      let deleteNo = this.payload.item.squareNo
      let squareNo = this.payload.item.squareNo
      let gubun = 'regi'
      if (deleteNo === undefined) {
        deleteNo = this.payload.item.cmntNo
        squareNo = this.payload.item.cmntSquareNo
        gubun = 'cmnt'
      }
      this.$confirm('삭제하시겠습니까?').then(result => {
        if (result) {
          this.$emit('onEvent', { fn: 'deleteGubun', item: this.payload.item, gubun: gubun, index: this.payload.index, deleteNo: deleteNo, squareNo: squareNo })
          this.close()
        }
      })
    }
  }
}
</script>
